import Form from 'src/utils/Form.js'

class Ramp extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`ramps/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`ramps?${parameters}`).then(then)
  }

  static publishRates(then) {
    return new Form().post('/ramps/publish-rates').then(then)
  }

  static notifyRates(then) {
    return new Form().post('/ramps/notify-rates').then(then)
  }

  create(then) {
    return super.post(`ramps`).then(then)
  }

  update(then) {
    return super.patch(`ramps/${this.id}`).then(then)
  }

  static exchangeRates(then) {
    return new Form().get('/ramps/exchange/rates').then(then);
  }

  static exchangeable(then) {
    return new Form().get('/ramps/currencies/exchangeable').then(then);
  }

  static list(then) {
      return new Form().get('/ramps/list').then(then);
  }

  destroy(then) {
    return super.delete(`ramps/${this.id}`).then(then)
  }

  createTier(then) {
    return super.post(`ramps/${this.id}/tiers`).then(then)
  }

  tiers(parameters, then) {
      return super.get(`ramps/${this.id}/tiers?${parameters}`).then(then)
  }
}

export default Ramp
